module.exports = __webpack_public_path__ + "static/media/favicon.63125cd7.png";